import { Container, Text, TextStyle } from "pixi.js";
import { Tooltip } from "by/gamefactory/cityversetycoon/scenes/common/components/Tooltip";
import { MyBuildingsTutorialResourcePackage } from "../../resources/MyBuildingsTutorialResourcePackage";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";

export class UpgradeTutorialThirdTooltipComponent extends Container {
    private static readonly TOOLTIP_TEXT = "PIGGY BOOSTER,\nEXCLUSIVE TO\nBUILDING OWNERS";

    private readonly tutorialResources: MyBuildingsTutorialResourcePackage;

    private tooltip: Tooltip;
    private tooltipText: Text;

    public constructor(tutorialResources: MyBuildingsTutorialResourcePackage) {
        super();
        this.tutorialResources = tutorialResources;
        this.build();
    }

    private build(): void {
        this.tooltip = new Tooltip(this.tutorialResources.assets_tutorials_mybuildings_tutorial_tooltip_4_png, 634, 387);
        this.addChild(this.tooltip);
        this.tooltipText = new Text(UpgradeTutorialThirdTooltipComponent.TOOLTIP_TEXT, new TooltipTextStyle());
        this.tooltipText.position.set(170, 80);
        this.addChild(this.tooltipText);
    }
}

export class TooltipTextStyle extends TextStyle {
    public constructor() {
        super({
            fill: "#ffc700",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 55,
            lineHeight: 76.8,
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 0.7,
            dropShadowDistance: 3,
            dropShadowBlur: 5,
            dropShadowColor: "#0D06064D"
        });
    }
}